import { useEffect } from "react";
import { EntranceAnimation } from "@/ui/components/EntranceAnimation";
import { useHomeViewModel } from "@/viewModels/useHomeViewModel";

/**
 * HomePage Component
 *
 * STRICT MVVM PATTERN - ZERO LOGIC
 * - Pure rendering only
 * - Single useEffect(onMount, []) ONLY
 * - All logic in useHomeViewModel
 *
 * This is the landing page for unauthenticated users.
 * It shows the entrance animation and consent flow.
 *
 * **Business Rules:**
 * - Authenticated users are redirected to /owner/trophy-room
 * - Users who have seen the animation skip to the final state
 * - Sign Up button is disabled until consent is accepted
 */
export const HomePage = () => {
  const { state, actions, onMount } = useHomeViewModel();

  // ONLY allowed useEffect - for mount lifecycle
  useEffect(onMount, []);

  return (
    <EntranceAnimation
      onComplete={actions.onAnimationComplete}
      consentAccepted={state.consentAccepted}
      onConsentChange={actions.onConsentChange}
      onSignUpClick={actions.goToSignup}
    />
  );
};

export default HomePage;
